<ng-container *ngIf="env.USE_TAILWIND; else nonTailwindSignupComplete">
    <rwidget-alert></rwidget-alert>
    <div id="main-content">
        <div class="relative flex items-center justify-center bg-white py-[22px]" *ngIf="env.IS_MOBILE_APP">
            <h1 class="text-center text-base font-bold leading-5">
                {{ 'SIGNUP_COMPLETE_TITLE' | translate }}
            </h1>
        </div>
        <div class="overflow-hidden">
            <div class="max-content max-content--secondary md:grid md:min-h-[73vh] md:grid-cols-2">
                <aside
                    class="pil-light-dark:justify-start relative hidden min-h-[20vh] items-center justify-center py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-[#F8F8F8] before:content-[''] dark:before:bg-contrast-black md:flex md:h-auto md:pr-8 md:before:right-0">
                    <rwidget-register-aside class="md:w-full lg:max-w-[26rem]"></rwidget-register-aside>
                </aside>
                <section
                    class="pil-light-dark:lg:pl-20 relative flex max-w-2xl items-stretch justify-start bg-white py-5 before:absolute before:-left-[100vw] before:-right-[100vw] before:bottom-0 before:top-0 before:-z-10 before:bg-white before:content-[''] md:h-auto md:pl-8 md:before:left-0">
                    <rwidget-signup-complete-form class="w-full self-stretch"></rwidget-signup-complete-form>
                </section>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #nonTailwindSignupComplete>
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <ridango-page-content-wrapper>
                <div class="ticket">
                    <rwidget-register-aside></rwidget-register-aside>
                    <div class="block__right-side-panel">
                        <rwidget-signup-complete-form></rwidget-signup-complete-form>
                    </div>
                </div>
            </ridango-page-content-wrapper>
        </div>
    </div>
</ng-template>
